import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CampaignPhase, Variants } from '@shared/constants';
import {
  AnyChallenge,
  UnselectionButtonConfig,
  UnselectionButtonDynamicComponent,
  UnselectionButtonFirstVariantConfig,
  UnselectionButtonSecondVariantConfig,
} from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';

@Component({
  selector: 'b2c-unselection-button',
  imports: [NgComponentOutlet],
  templateUrl: './unselection-button.component.html',
})
export class UnselectionButtonComponent extends BaseComponent {
  challenge = input.required<AnyChallenge>();

  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  protected config: UnselectionButtonConfig =
    this.loyaltyChallengeConfig.components.challenges.elements
      .unselectionButton;

  protected variant = computed(() => this.config.variant ?? Variants.VARIANT_1);

  public components: Signal<
    UnselectionButtonDynamicComponent<UnselectionButtonConfig>
  > = computed(() => {
    return {
      [this.Variants.VARIANT_1]: {
        component: Variant1Component,
        inputs: {
          phase: this.phase(),
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
          config: this.config as UnselectionButtonFirstVariantConfig,
        },
      },
      [this.Variants.VARIANT_2]: {
        component: Variant2Component,
        inputs: {
          phase: this.phase(),
          challenge: this.challenge(),
          isBisCampaign: this.isBisCampaign(),
          isEventChallenge: this.isEventChallenge(),
          config: this.config as UnselectionButtonSecondVariantConfig,
        },
      },
    };
  });
}
